import { render, staticRenderFns } from "./tableRow.vue?vue&type=template&id=61b5e346"
import script from "./tableRow.vue?vue&type=script&lang=js"
export * from "./tableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports